import { render, staticRenderFns } from "./personnel.vue?vue&type=template&id=50af9467"
import script from "./personnel.vue?vue&type=script&lang=js"
export * from "./personnel.vue?vue&type=script&lang=js"
import style0 from "./personnel.vue?vue&type=style&index=0&id=50af9467&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports